import { useShouldDisplayL1RoleTab } from "../display-l1-role-tab";

export const useJobPagePath = () => {
  const shouldDisplayL1Tab = useShouldDisplayL1RoleTab();

  return {
    jobsPath: shouldDisplayL1Tab ? "/role-jobs" : "/jobs",
  };
};
